import { Row, Button } from 'antd'
import React, { useState } from 'react'
import { useTranslation } from 'next-i18next'
import { PlusOutlined } from '@ant-design/icons'
import { CustomCol, CustomTitle } from 'src/components'
import styles from './IntegrationTransactionListHeader.module.scss'
import BuyMorBalanceModal from '../BuyMoreBalanceModal/BuyMoreBalanceModal'

const IntegrationTransactionListHeader: React.FC = () => {
  const { t } = useTranslation()
  const [isModalVisible, setIsModalVisible] = useState(false)

  return <>
    <div className={styles.content}>
      <Row>
        <CustomCol lg={17}>
          <CustomTitle label={t('developers.ProjectsAvailable')} type={null} />
        </CustomCol>
        <CustomCol lg={6}>
          <Button
            className={styles.button}
            type='primary'
            icon={<PlusOutlined />}
            onClick={() => setIsModalVisible(true)}
            block
          >
            {t('developers.BuyMoreBalance')}
          </Button>
        </CustomCol>
      </Row>
    </div>
    <BuyMorBalanceModal
      isModalVisible={isModalVisible}
      setIsModalVisible={setIsModalVisible}
    />
  </>
}

export default IntegrationTransactionListHeader
